import { makePlateConfig } from './plateConfigCore';

// web-rnw half of the plate-config pair. The ONLY thing this file owns is the
// storage port: localStorage. `async` so a localStorage that throws (private
// mode, storage disabled) rejects into the same try/catch that already guards
// the native reads, rather than throwing synchronously.
//
// ⚠️ This file used to be a 232-line character-for-character copy of its
// native twin, and a hook added to only one side would have compiled clean and
// exploded at runtime on one platform. That risk is gone by construction: the
// twins no longer hold behaviour, only a storage port, so anything added to
// `./plateConfigCore.ts` reaches both platforms at once.
const readItem = async (key: string): Promise<string | null> =>
  localStorage.getItem(key);
const writeItem = async (key: string, value: string): Promise<void> =>
  localStorage.setItem(key, value);

export const {
  loadPlateBar,
  persistPlateBar,
  loadPlateInventory,
  persistPlateInventory,
  loadRoundingContext,
  loadHandheldStep,
  persistHandheldStep,
  loadPlateLoadShape,
  persistPlateLoadShape,
  useRoundingContextRef,
  useRoundingContext,
} = makePlateConfig({ readItem, writeItem });

export { BAR_OPTIONS } from './plateConfigCore';
export type { PlateLoadShape } from './plateConfigCore';
